
import { Component, Vue, Prop } from "vue-property-decorator";
import ActionActivitorEdit from "./EditActions/ActionActivitorEdit.vue";
import ActionGameStatusEdit from "./EditActions/ActionGameStatusEdit.vue";
import ActionQuestEdit from "./EditActions/ActionQuestEdit.vue";
import ActionTimerEdit from "./EditActions/ActionTimerEdit.vue";
import ActionVisibilityEdit from "./EditActions/ActionVisibilityEdit.vue";
import ActionInventoryEdit from "./EditActions/ActionInventoryEdit.vue";
import ActionCustomEdit from "./EditActions/ActionCustomEdit.vue";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { Game } from "@/models/Game";

@Component({
  components: {
    ActionActivitorEdit,
    ActionGameStatusEdit,
    ActionInventoryEdit,
    ActionQuestEdit,
    ActionTimerEdit,
    ActionVisibilityEdit,
    ActionCustomEdit,
  },
})
class ActionBoxTab extends Vue {
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default: null }) readonly objectName!: string;
  @Prop({ default: false }) readonly contentData!: ActionList;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: "" }) readonly mapPoiKey!: string;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: "" }) readonly questKey!: string;
  timerAction = false;
  poiActive = false;
  poiVisilbe = false;
  gameStatus = false;
  qStatus = false;
  invAction = false;
  customAction = false;
  questEdit = false;

  get getContentData(): ActionList {
    return this.contentData;
  }

  get getActive(): boolean {
    if (Object.keys(this.contentData).includes(this.objectName)) {
      return true;
    } else {
      return false;
    }
  }

  openEditTabs(): void {
    if (this.objectName === "timerAction") {
      this.timerAction = true;
    }
    if (this.objectName === "poiActiveAction") {
      this.poiActive = true;
    }
    if (this.objectName === "poiVisibleAction") {
      this.poiVisilbe = true;
    }
    if (this.objectName === "qStatusAction") {
      this.qStatus = true;
    }
    if (this.objectName === "invAction") {
      this.invAction = true;
    }
    if (this.objectName === "customAction") {
      this.customAction = true;
    }
    if (this.objectName === "gameStatusAction") {
      this.gameStatus = true;
    }
  }
  cancel(): void {
    this.timerAction = false;
    this.poiActive = false;
    this.poiVisilbe = false;
    this.qStatus = false;
    this.invAction = false;
    this.gameStatus = false;
    this.customAction = false;
  }

  update(contentData: any): void {
    try {
      if (this.objectName === "timerAction") {
        this.getContentData.timerAction = contentData;
      }
      if (this.objectName === "poiActiveAction") {
        this.getContentData.poiActiveAction = contentData;
      }
      if (this.objectName === "poiVisibleAction") {
        this.getContentData.poiVisibleAction = contentData;
      }
      if (this.objectName === "qStatusAction") {
        this.getContentData.qStatusAction = contentData;
      }
      if (this.objectName === "invAction") {
        this.getContentData.invAction = contentData;
      }
      if (this.objectName === "customAction") {
        this.getContentData.customAction = contentData;
      }
      if (this.objectName === "gameStatusAction") {
        this.getContentData.gameStatusAction = contentData;
      }
      var data = {
        contentData: this.getContentData,
        actionDetails: contentData,
        objectName: this.objectName,
      };
      this.cancel();
      this.$emit("update", data);
    } catch (error) {
      console.log(error);
    }
  }

  deleteAction(): void {
    if (this.objectName === "timerAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.timerAction;
      }
    }
    if (this.objectName === "poiActiveAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.poiActiveAction;
      }
    }
    if (this.objectName === "poiVisibleAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.poiVisibleAction;
      }
    }
    if (this.objectName === "qStatusAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.qStatusAction;
      }
    }
    if (this.objectName === "invAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.invAction;
      }
    }
    if (this.objectName === "customAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.customAction;
      }
    }
    if (this.objectName === "gameStatusAction") {
      if (this.getContentData !== undefined) {
        delete this.getContentData.gameStatusAction;
      }
    }
    var data = {
      contentData: this.getContentData,
      objectName: this.objectName,
    };
    this.cancel();
    this.$emit("deleteAction", data);
  }
}

export default ActionBoxTab;
